import { render, staticRenderFns } from "./company-details-review.vue?vue&type=template&id=333fe9af&scoped=true&lang=pug"
import script from "./company-details-review.vue?vue&type=script&lang=ts"
export * from "./company-details-review.vue?vue&type=script&lang=ts"
import style0 from "./company-details-review.vue?vue&type=style&index=0&id=333fe9af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333fe9af",
  null
  
)

export default component.exports